import { get as _get } from 'lodash-es';
import { __ } from '../../../i18n';

export default function restSetMyPaymentMethod(result) {
  const message = _get(result, 'message');

  if (message) {
    throw new Error(
      __(
        'Payment method selected is not available. Please choose another payment method.'
      )
    );
  }

  return {
    order_number: result,
  };
}
